module.exports = __webpack_public_path__ + "static/img/kjdy03.88b2ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy03.jpg
// module id = 1416
// module chunks = 0